import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import ForcePasswordChange from './components/ForcePasswordChange';
import CookieBanner from './components/CookieBanner';
import LoginPage           from './pages/LoginPage';
import RegisterPage        from './pages/RegisterPage';
import AppShell            from './pages/AppShell';
import AuthCallbackPage    from './pages/AuthCallbackPage';
import DeleteAccountPage   from './pages/DeleteAccountPage';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  render() {
    if (this.state.error) return (
      <div style={{ padding:20, margin:20, background:'#FEE2E2', color:'#C0312D', borderRadius:12, fontFamily:'sans-serif' }}>
        <strong>Feil:</strong> {this.state.error?.message}
        <br/>
        <button style={{ marginTop:10, padding:'8px 16px', background:'#C0312D', color:'white', border:'none', borderRadius:8, cursor:'pointer' }}
          onClick={() => { this.setState({ error:null }); window.location.reload(); }}>
          Last inn på nytt
        </button>
      </div>
    );
    return this.props.children;
  }
}

function PrivateRoute({ children }) {
  const { user, loading, refreshUser } = useAuth();
  if (loading) return <div style={styles.splash}><div style={styles.spinner}></div></div>;
  if (!user)   return <Navigate to="/logg-inn" replace />;
  return (
    <ErrorBoundary>
      {children}
      {user.must_change_password && <ForcePasswordChange onComplete={refreshUser} />}
    </ErrorBoundary>
  );
}

export default function App() {
  return (
    <ThemeProvider>
    <ToastProvider>
    <AuthProvider>
      <CookieBanner />
      <BrowserRouter>
        <Routes>
          <Route path="/logg-inn"      element={<LoginPage />} />
          <Route path="/registrer"     element={<RegisterPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/slett-konto"   element={
            <PrivateRoute><DeleteAccountPage /></PrivateRoute>
          } />
          <Route path="/*" element={
            <PrivateRoute>
              <AppShell />
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ToastProvider>
    </ThemeProvider>
  );
}

const styles = {
  splash:  { height:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'#F7F5FF' },
  spinner: { width:40, height:40, border:'4px solid #EAE8F8', borderTop:'4px solid #7C6FF7', borderRadius:'50%', animation:'spin 0.8s linear infinite' },
};
